import { ICON_MAP } from './iconLibraryMap';
import { IconName } from './iconLibraryTypes';
import { IconLibraryWeight } from './iconLibraryWeights';
import { useTheme } from '@mui/material';

export interface IconLibraryProps {
  color?: string;
  useContrastColor?: boolean;
  iconName: IconName;
  size?: number;
  weight?: IconLibraryWeight;
  mirrored?: boolean;
  style?: React.CSSProperties;
}

export const IconLibrary = ({
  color,
  useContrastColor = false,
  iconName,
  size = 24,
  weight = 'duotone',
  mirrored = false,
  style,
}: IconLibraryProps) => {
  const theme = useTheme();
  const subColor = useContrastColor ? 'contrastText' : 'main';

  // Check if color is a direct CSS color value (starts with # or rgb/rgba)
  // If so, use it directly; otherwise, look it up in the theme palette
  const isDirectColor = color && (color.startsWith('#') || color.startsWith('rgb'));
  const iconColor = isDirectColor
    ? color
    : theme.palette[color as keyof typeof theme.palette]?.[subColor as keyof typeof theme.palette.primary] || theme.palette.primary?.[subColor as keyof typeof theme.palette.primary];

  const Icon = ICON_MAP[iconName];

  if (!Icon) {
    console.warn(`Icon with name ${iconName} not found in library.`);
    return null;
  }

  return <Icon size={size} weight={weight} color={iconColor} style={style} mirrored={mirrored} />;
};
